import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import { View } from "react-native";
import { Text } from "react-native-paper";

type Props = {
	text: string;
	buttonProps?: {
		cta: string;
		onPress: () => void;
	};
	title?: string;
	fontSize?: number;
	alignItems?: "flex-start" | "center";
	backgroundColor?: string;
	icon?: keyof typeof Icon.glyphMap;
	bottomComponent?: React.ReactNode;
};

const InfoAlert = ({
	text,
	buttonProps,
	title,
	fontSize = 14,
	alignItems = "center",
	backgroundColor,
	icon,
	bottomComponent,
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			padding={16}
			borderRadius={theme.roundness}
			backgroundColor={backgroundColor || theme.colors.primaryContainer}
		>
			<View
				style={{
					flexDirection: "row",
					gap: 8,
					alignItems,
				}}
			>
				<Icon
					name={icon || "information-outline"}
					size={24}
					color={theme.colors.onSurfaceVariant}
				/>

				<Box flex={1}>
					{title && <Text variant="labelMedium">{title}</Text>}
					<CustomMarkdownRenderer
						text={text}
						fontSize={fontSize}
						customStyles={{
							text: {
								color: theme.colors.onSurfaceVariant,
							},
							paragraph: {
								marginVertical: 0,
							},
						}}
					/>
					{bottomComponent}
				</Box>
				{buttonProps && (
					<Button onPress={buttonProps.onPress}>{buttonProps.cta}</Button>
				)}
			</View>
		</Box>
	);
};

export default InfoAlert;
